import React, { useContext, useEffect, useState } from "react";
import MobileViewGlobal from "./MobileView";
import VideoPlayer from "../players/VideoPlayer";
import ActionPointHandler from "../ActionPoint/ActionPointHandler";
import ChatlistAllView from "../Chat/Views/ChatListAll.MobileView";

import EventUserComponent from "../EventUser/EventUserComponent";

import MobileNavigationsViews, { VIEWS } from "./MobileNavigationViews";
import Navigation from "../Navigation/Navigation";
import { ScreenContext } from "../../contexts/ScreenContext";
import PublicChatToggleView from "../Chat/Views/PublicChatToggleView";
import { isMobileOrTablet } from "./MobileClassRenderer";

export default function EventMobileInitView({
  mainPage,
  event,
  children = null,
}) {
  const { inMobileView } = useContext(ScreenContext);

  const isWhereByRoom = mainPage?.kind === 3 || mainPage?.kind === 4;
  const isHomeView = inMobileView == VIEWS.home;
  const isUserView = inMobileView == VIEWS.chatMessList;
  
  return (
    <>
      <MobileViewGlobal
        className="wrap-mobile"
        style={{
          backgroundColor:
            isWhereByRoom && isHomeView ? "#141414" : "",
        }}
      >
        <Navigation />

        <MobileNavigationsViews
          userView={null}
          homeView={
            <>
              {children ? children() : <VideoPlayer {...mainPage} />}
              <>
                {mainPage.actionPoints && (
                  <ActionPointHandler
                    actionInfo={{
                      header: mainPage.heading,
                      description: mainPage.description,
                    }}
                    actionPoints={mainPage.actionPoints}
                  />
                )}
              </>
            </>
          }
          addUserView={<EventUserComponent />}
        />

        {/* Chat shall always be mounted to perist state in all views */}
        <div
          style={{ display: `${isUserView ? "block" : "none"}` }}
        >
          <ChatlistAllView
            {...{
              event,
              page: mainPage?.slug,
              showPublicChat: mainPage?.showPublicChat,
              showCorporateChat: mainPage?.showCorporateChat,
              corporateOrganization: mainPage?.corporateOrganization,
            }}
          />
        </div>
      </MobileViewGlobal>
    
      {isMobileOrTablet() && (
        <div style={{ display: `${isHomeView ? "block" : "none"}` }}>
          <PublicChatToggleView
            {...{
              event,
              page: mainPage?.slug,
              showPublicChat: mainPage?.showPublicChat,
              showCorporateChat: mainPage?.showCorporateChat,
              corporateOrganization: mainPage?.corporateOrganization,
            }}
          />
        </div>
      )}
    </>
  );
}
